<template>
  <div class="main-container">
    <div class="c-table-container">
      <h4>کاشی و سرامیک سینا (رشته فعالیت)</h4>
      <GrowthStatisticsTable
          :sales-growth="growthStatisticsTableData.salesGrowth"
          :productivity-growth="growthStatisticsTableData.productivityGrowth"
          :improving-prices="growthStatisticsTableData.improvingPrices"/>
    </div>

    <div class="chart-container">
      <div class="chart-box">
        <h4>فروش (همت)</h4>
        <BarChart :data="salesChartData"/>
      </div>
      <div class="chart-box">
        <h4>فروش در دو محصول اصلی (همت)</h4>
        <BarChart :data="mainProductsSalesChartData"/>
      </div>
    </div>

    <div class="chart-container">
      <div class="chart-box">
        <h4>صادرات (میلیون دلار)</h4>
        <BarChart :data="exportChartData"/>
      </div>
      <div class="chart-box">
        <h4>تولید در دو محصول اصلی (میلیون تن)</h4>
        <BarChart :data="productionChartData"/>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/PerformanceManagement/EconomicOperationReport/BarChart.vue';
import GrowthStatisticsTable from '@/components/PerformanceManagement/EconomicOperationReport/GrowthStatisticsTable.vue';

export default {
  components: {
    BarChart,
    GrowthStatisticsTable
  },
  data() {
    return {
      growthStatisticsTableData: {
        salesGrowth: '7.3%',
        productivityGrowth: '-10.8%',
        improvingPrices: '20.3%',
      },

      salesChartData: {
        labels: ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور'],
        datasets: [
          {
            label: 'فروش تجمعی ۱۴۰۲',
            backgroundColor: '#007bff',
            data: [2.3, 9.3, 14.2, 16.5, 18.5, 27.9]
          },
          {
            label: 'بودجه تجمعی ۱۴۰۳',
            backgroundColor: '#28a745',
            data: [3.6, 10.5, 16.3, 19.8, 22.9, 40.1]
          },
          {
            label: 'فروش تجمعی ۱۴۰۳',
            backgroundColor: '#be3434',
            data: [1.9, 9.6, 15.1, 16.5, 18.2, 26.9]
          }
        ]
      },

      mainProductsSalesChartData: {
        labels: ['کاشی و سرامیک (+7%)', 'گرانول و چینی بهداشتی (+47%)'],
        datasets: [
          {
            label: '1402',
            backgroundColor: '#ffc107',
            data: [0.87, 0.92]
          },
          {
            label: '1403',
            backgroundColor: '#17a2b8',
            data: [0.07, 0.11]
          },
        ]
      },

      exportChartData: {
        labels: ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور'],
        datasets: [
          {
            label: 'صادرات تجمعی ۱۴۰۲',
            backgroundColor: '#007bff',
            data: [54, 107, 168, 185, 195, 257]
          },
          {
            label: 'بودجه تجمعی ۱۴۰۳',
            backgroundColor: '#28a745',
            data: [34, 67, 67, 77, 87, 191]
          },
          {
            label: 'صادرات تجمعی ۱۴۰۳',
            backgroundColor: '#be3434',
            data: [44, 97, 162, 175, 179, 189]
          }
        ]
      },

      productionChartData: {
        labels: ['کاشی و سرامیک (میلیون تن)', 'گرانول و چینی بهداشتی (میلیون تن)'],
        datasets: [
          {
            label: '1402',
            backgroundColor: '#ffc107',
            data: [0.82, 0.71]
          },
          {
            label: '1403',
            backgroundColor: '#17a2b8',
            data: [1.07, 0.91]
          },
        ]
      },
    }
  }
}
</script>

<style scoped>
.main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  direction: rtl;
  padding: 1.5vw;
  background-color: #f0f2f5;
  position: relative;
}

.chart-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 1.5vw;
}

.chart-box {
  width: 48%;
  background-color: white;
  padding: 1vw;
  border-radius: .5vw;
  box-shadow: 0 0 .5vw rgba(0, 0, 0, 0.1);
}

.chart-box h4 {
  font-size: .9vw !important;
  margin-bottom: .6vw;
  text-align: center;
  color: #343a40;
}

.c-table-container {
  width: 100%;
  background-color: white;
  padding: 1.5vw;
  border-radius: .5vw;
  box-shadow: 0 0 .5vw rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5vw;
}

.c-table-container h4 {
  font-size: .9vw !important;
  margin-bottom: .9vw;
  text-align: center;
  color: #343a40;
}
</style>
